import storage from "../utils/storage";
import { getUser, AuthUser } from "../features/auth";

export async function loadUser() {
  if (storage.getToken()) {
    try {
      const response = await getUser();
      if (response && response.user) {
        console.log(response);

        // Map response data to the AuthUser type
        const userData: AuthUser = {
          id: response.user.id,
          name: response.user.name,
          username: response.user.username,
          isActive: response.user.is_active === 1, // Convert to boolean
          createdAt: response.user.created_at,
          updatedAt: response.user.updated_at,
          role: response.user.role, // Include the role object
          clients: response.user.clients, // Use the clients array directly
        };

        return userData;
      }
      return null;
    } catch (error) {
      console.error("Error loading user:", error);
      return null;
    }
  }
  return null;
}
